import { connect } from "react-redux";
import Container from "./container";
import { actionCreators as userActions } from "stores/user";

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
        passwordResetVerify: (verifyParam) => {
            return dispatch(userActions.passwordResetVerify(verifyParam));
        },
        passwordReset: (password, verifyParam) => {
            return dispatch(userActions.passwordReset(password, verifyParam));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
